import { render } from "./digitalTickets.view.vue?vue&type=template&id=ac1dd64e&ts=true"
import script from "./digitalTickets.view.vue?vue&type=script&lang=ts"
export * from "./digitalTickets.view.vue?vue&type=script&lang=ts"

import "./digitalTickets.view.vue?vue&type=style&index=0&id=ac1dd64e&lang=scss"

import exportComponent from "/agent/_work/1/s/Customer/onlinekiosk_vue_js/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__